import React, { useState ,useEffect} from "react";
import { useNavigate } from "react-router-dom";
// import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import load from "../../assets/Images/loader.gif";
import { toast } from "react-toastify";

const BusinessMyDashboard = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [contactData, setContactData] = useState(null);

  const [leadFromDate,setLeadFromDate]=useState("");
  const [leadtoDate,setLeadToDate]=useState("");
  const [leadData, setLeadData] = useState(null);

  useEffect(() => {
    const currentDate = new Date();
    const fiveDaysBefore = new Date();
    fiveDaysBefore.setDate(currentDate.getDate() - 6);

    setFromDate(fiveDaysBefore.toISOString().split('T')[0]);
    setToDate(currentDate.toISOString().split('T')[0]);

    setLeadFromDate(fiveDaysBefore.toISOString().split('T')[0]);
    setLeadToDate(currentDate.toISOString().split('T')[0]);
}, []);

useEffect(() => {
  const fetchApi = async () => {
      const url = process.env.REACT_APP_API_URL;
      const data = {
          Action: "getUsersContactCount",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          fromDate: fromDate,
          password: sessionStorage.getItem("password"),
          toDate: toDate,
          username: sessionStorage.getItem("userName"),
      };
      try {
          const response = await fetch(url, {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
          });
          const result = await response.json();
          // console.log("getUsersContactCount", result.Response);
          if (response.ok && result.Status==="Success" ) {
              setContactData(result.Response);
          }else{
            toast.warning("Please Select the value of limit(29 days)", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 500,
            });
            setContactData("");
          }
      } catch (error) {
          console.log("Error fetching data", error.message);
      }
  };

  if (fromDate && toDate) {
      fetchApi();
  }
}, [fromDate, toDate]);

useEffect(() => {
  const fetchApi = async () => {
      const url = process.env.REACT_APP_API_URL;
      const data = 
      {
        "Action": "getUsersLeadCount",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "fromDate": leadFromDate,
        "password": sessionStorage.getItem("password"),
        "toDate": leadtoDate,
        "username": sessionStorage.getItem("userName")
    };
      try {
          const response = await fetch(url, {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
          });
          const result = await response.json();
          // console.log("setLeadData", result.Response);
          if (response.ok && result.Status==="Success" ) {
            setLeadData(result.Response);
          }else{
            toast.warning("Please Select the value of limit(29 days)", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 500,
            });
            setContactData("");
          }
      } catch (error) {
          console.log("Error fetching data", error.message);
      }
  };

  if (leadFromDate && leadtoDate) {
      fetchApi();
  }
}, [leadFromDate, leadtoDate]);


  const handleDateChange = (event) => {
    const { name, value } = event.target;
    if (name === "fromDate") setFromDate(value);
    if (name === "toDate") setToDate(value);
    if (name === "laedFromDate") setLeadFromDate(value);
    if (name === "leadtoDate") setLeadToDate(value);
  };


  const getContactCount = async () => {
    try {
      setLoading(true);
      const url = process.env.REACT_APP_API_URL;
      const data = {
        Action: "getUsersContactCount",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        fromDate: fromDate,
        password: sessionStorage.getItem("password"),
        toDate: toDate,
        username: sessionStorage.getItem("userName"),
      };
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      // console.log("getUsersContactCount", result.Response);
      if (response.ok && result.Status==="Success") {
        setLoading(false);
        setContactData(result.Response);
      } else {
        toast.warning("Please Select the value of limit(31 days)", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 500,
        });
      }
    } catch (error) {
      console.log("Error fetching data", error.message);
    }
    finally{
      setLoading(false);
    }
  };

  const getLeadCount = async () => {
    try {
      setLoading(true);
      const url = process.env.REACT_APP_API_URL;
      const data = {
        "Action": "getUsersLeadCount",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "fromDate": leadFromDate,
        "password": sessionStorage.getItem("password"),
        "toDate": leadtoDate,
        "username": sessionStorage.getItem("userName")
    };
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      // console.log("getLeadCount", result.Response);
      if (response.ok && result.Status==="Success") {
        setLoading(false);
        setLeadData(result.Response);
      } else {
        toast.warning("Please Select the value of limit(31 days)", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 500,
        });
      }
    } catch (error) {
      console.log("Error fetching data", error.message);
    }
    finally{
      setLoading(false);
    }
  };

  const navigate = useNavigate();
  const redirectBusinessPage = () => {
    navigate("/business");
  };


  const currentDate = new Date().toISOString().split('T')[0];

  return (
    <>
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectBusinessPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">My Dashboard</span>
        </div>
        {/* Navigation tabs:  Contacts , Leads*/}
        <div className=" container-fluid">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <a
                className="nav-link active"
                data-bs-toggle="tab"
                href="#contact"
              >
                Contacts
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-bs-toggle="tab" href="#leads">
                Leads
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="tab-content tab-main-content">
        {/* ****************** Contacts TAB ************* */}
        
        <div className="tab-pane fade show active mt-5" id="contact">
  {loading ? (
    <div className="loader-wrapper">
      <div className="loader">
        <img src={load} alt="loading...."></img>
      </div>
    </div>
  ) : (
    <div className="container-fluid rounded shadow mt-4">
      <div className="row">
        <div className="col-md-5">
          <label>From Date</label>
          <input
            type="date"
            name="fromDate"
            value={fromDate}
            onChange={handleDateChange}
            className="form-control input-text form-control-sm mt-1"
            max={currentDate} // Set max date to today
          />
        </div>
        <div className="col-md-5">
          <label>To Date</label>
          <input
            type="date"
            name="toDate"
            value={toDate}
            onChange={handleDateChange}
            className="form-control input-text form-control-sm mt-1"
            max={currentDate} // Set max date to today
          />
        </div>
        <div className="col-md-2 text-center">
          <button
            className="btn text-light dashboard-sub-btn w-75"
            style={{ marginTop: "45px" }}
            onClick={getContactCount}
          >
            Submit
          </button>
        </div>
      </div>

      <div className="container-fluid mt-4 table-responsive">
        {contactData && (
          <div className="row">
            <div className="col">
              <div id="tv_Hint1" className="tv_Hint1-close mb-1">
                Contact: Total Created:{" "}
                {contactData.reduce(
                  (sum, user) =>
                    sum +
                    user.Dates.reduce(
                      (dateSum, date) =>
                        dateSum + parseInt(date.ContctInfo.Contactcreated),
                      0
                    ),
                  0
                )}{" "}
                / Closed:{" "}
                {contactData.reduce(
                  (sum, user) =>
                    sum +
                    user.Dates.reduce(
                      (dateSum, date) =>
                        dateSum + parseInt(date.ContctInfo.ContactToLeadCreated),
                      0
                    ),
                  0
                )}
              </div>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <td className="header-back-day">Name</td>
                    {contactData[0].Dates.slice().reverse().map((date) => (
                      <td className="header-back-day" key={date.date}>
                        {new Date(date.date).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                        })}
                      </td>
                    ))}
                    <td className="header-back-day">Total</td>
                  </tr>
                </thead>
                <tbody>
                  {contactData.map((user) => (
                    <tr key={user.UserName}>
                      <td className="rect-bg">{user.UserName}</td>
                      {user.Dates.slice().reverse().map((date) => (
                        <td className="rect-bg" key={date.date}>
                          {date.ContctInfo.Contactcreated}/
                          {date.ContctInfo.ContactToLeadCreated}
                        </td>
                      ))}
                      <td className="header-back">
                        {user.Dates.reduce(
                          (sum, date) =>
                            sum + parseInt(date.ContctInfo.Contactcreated),
                          0
                        )}
                        /
                        {user.Dates.reduce(
                          (sum, date) =>
                            sum + parseInt(date.ContctInfo.ContactToLeadCreated),
                          0
                        )}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td className="header-back-day">Total</td>
                    {contactData[0].Dates.slice().reverse().map((_, index) => {
                      const totalCreated = contactData.reduce(
                        (sum, user) =>
                          sum +
                          parseInt(
                            user.Dates[user.Dates.length - 1 - index].ContctInfo
                              .Contactcreated
                          ),
                        0
                      );
                      const totalClosed = contactData.reduce(
                        (sum, user) =>
                          sum +
                          parseInt(
                            user.Dates[user.Dates.length - 1 - index].ContctInfo
                              .ContactToLeadCreated
                          ),
                        0
                      );

                      return (
                        <td className="header-back-day" key={index}>
                          {totalCreated}/{totalClosed}
                        </td>
                      );
                    })}
                    <td className="header-back-day">
                      {contactData.reduce(
                        (sum, user) =>
                          sum +
                          user.Dates.reduce(
                            (dateSum, date) =>
                              dateSum + parseInt(date.ContctInfo.Contactcreated),
                            0
                          ),
                        0
                      )}
                      /
                      {contactData.reduce(
                        (sum, user) =>
                          sum +
                          user.Dates.reduce(
                            (dateSum, date) =>
                              dateSum +
                              parseInt(date.ContctInfo.ContactToLeadCreated),
                            0
                          ),
                        0
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  )}
       </div>


        {/* ****************** Leads TAB ************* */}
        <div className="tab-pane fade show" id="leads">
  {loading ? (
    <div className="loader-wrapper">
      <div className="loader">
        <img src={load} alt="loading...."></img>
      </div>
    </div>
  ) : (
    <div className="container-fluid rounded shadow mt-4">
      <div className="row">
        <div className="col-md-5">
          <label>From Date</label>
          <input
            type="date"
            name="leadFromDate"
            value={leadFromDate}
            onChange={handleDateChange}
            className="form-control input-text form-control-sm mt-1"
            max={currentDate} // Set max date to today
          />
        </div>
        <div className="col-md-5">
          <label>To Date</label>
          <input
            type="date"
            name="leadToDate"
            value={leadtoDate}
            onChange={handleDateChange}
            className="form-control input-text form-control-sm mt-1"
            max={currentDate} // Set max date to today
          />
        </div>
        <div className="col-md-2 text-center">
          <button
            className="btn text-light dashboard-sub-btn w-75"
            style={{ marginTop: "45px" }}
            onClick={getLeadCount}
          >
            Submit
          </button>
        </div>
      </div>

      <div className="container-fluid mt-4 table-responsive">
        {leadData && (
          <div className="row">
            <div className="col">
              <div id="tv_Hint1" className="tv_Hint1-close mb-1">
                Lead: Total Created :{" "}
                {leadData.reduce(
                  (sum, user) =>
                    sum +
                    user.Dates.reduce(
                      (dateSum, date) =>
                        dateSum + parseInt(date.LeadInfo.Leadcreated),
                      0
                    ),
                  0
                )}{" "}
                / Closed :{" "}
                {leadData.reduce(
                  (sum, user) =>
                    sum +
                    user.Dates.reduce(
                      (dateSum, date) =>
                        dateSum + parseInt(date.LeadInfo.LeadQualified),
                      0
                    ),
                  0
                )}
              </div>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <td className="header-back-day">Name</td>
                    {leadData[0].Dates.slice().reverse().map((date) => (
                      <td className="header-back-day" key={date.date}>
                        {new Date(date.date).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                        })}
                      </td>
                    ))}
                    <td className="header-back-day">Total</td>
                  </tr>
                </thead>
                <tbody>
                  {leadData.map((user) => (
                    <tr key={user.UserName}>
                      <td className="rect-bg">{user.UserName}</td>
                      {user.Dates.slice().reverse().map((date) => (
                        <td className="rect-bg" key={date.date}>
                          {date.LeadInfo.Leadcreated}/
                          {date.LeadInfo.LeadQualified}
                        </td>
                      ))}
                      <td className="header-back">
                        {user.Dates.reduce(
                          (sum, date) =>
                            sum + parseInt(date.LeadInfo.Leadcreated),
                          0
                        )}
                        /
                        {user.Dates.reduce(
                          (sum, date) =>
                            sum + parseInt(date.LeadInfo.LeadQualified),
                          0
                        )}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td className="header-back-day">Total</td>
                    {leadData[0].Dates.slice().reverse().map((_, index) => {
                      const totalCreated = leadData.reduce(
                        (sum, user) =>
                          sum +
                          parseInt(
                            user.Dates[user.Dates.length - 1 - index].LeadInfo
                              .Leadcreated
                          ),
                        0
                      );
                      const totalClosed = leadData.reduce(
                        (sum, user) =>
                          sum +
                          parseInt(
                            user.Dates[user.Dates.length - 1 - index].LeadInfo
                              .LeadQualified
                          ),
                        0
                      );

                      return (
                        <td className="header-back-day" key={index}>
                          {totalCreated}/{totalClosed}
                        </td>
                      );
                    })}
                    <td className="header-back-day">
                      {leadData.reduce(
                        (sum, user) =>
                          sum +
                          user.Dates.reduce(
                            (dateSum, date) =>
                              dateSum + parseInt(date.LeadInfo.Leadcreated),
                            0
                          ),
                        0
                      )}
                      /
                      {leadData.reduce(
                        (sum, user) =>
                          sum +
                          user.Dates.reduce(
                            (dateSum, date) =>
                              dateSum + parseInt(date.LeadInfo.LeadQualified),
                            0
                          ),
                        0
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  )}
</div>

      </div>
    </>
  );
};

export default BusinessMyDashboard;
